export default __webpack_public_path__ + "static/media/deposit-qrcode-step1.9c385eee.png";